import React from "react";
import { Icon } from "@iconify/react";

// `code` stays as the ISO key used in the DB/i18n ({ en, mk, sq }); only the
// displayed flag/label changes. English uses the UK flag (European convention),
// Macedonian the MK flag, Albanian the AL flag.
export const FORM_LANGS = [
  { code: "en", label: "EN", flag: "flag:gb-4x3" },
  { code: "mk", label: "MK", flag: "flag:mk-4x3" },
  { code: "sq", label: "AL", flag: "flag:al-4x3" },
] as const;

export type FormLang = (typeof FORM_LANGS)[number]["code"];

interface LanguageTabsProps {
  active: string;
  onChange: (lang: FormLang) => void;
}

// Reusable language switcher for multilingual admin modals.
// Shows EN / MK / SQ tabs; the parent renders the fields for the active tab.
const LanguageTabs: React.FC<LanguageTabsProps> = ({ active, onChange }) => (
  <div className="flex gap-1 border-b border-gray-200 mb-6">
    {FORM_LANGS.map((l) => (
      <button
        key={l.code}
        type="button"
        onClick={() => onChange(l.code)}
        className={`flex items-center gap-2 px-5 py-2 text-sm font-semibold rounded-t-lg transition-colors -mb-px border-b-2 ${
          active === l.code
            ? "border-brand-500 text-brand-700 bg-brand-50"
            : "border-transparent text-gray-500 hover:text-brand-600 hover:bg-brand-50"
        }`}
      >
        <Icon icon={l.flag} className="w-5 h-auto rounded-sm shadow-sm" />
        {l.label}
      </button>
    ))}
  </div>
);

export default LanguageTabs;
